import Accordion, {AccordionProps} from '@mui/material/Accordion';
import {styled} from '@mui/material/styles';

export const AccordionStyled = styled(Accordion)<AccordionProps>(() => ({
	boxShadow: 'none',
	'&.Mui-expanded': {
		margin: '0 0 16px 0',
	},
	'&.Mui-expanded::before': {
		opacity: 1,
	},
}));
